<template>
  <inventoryProductsForm :typeEndPoint="'inventoryProductsForm'" :dataParams="{}"/>
</template>
<script>
import inventoryProductsForm from '@/components/modules/inventory/products/form'
export default {
  name: 'inventoryProductsCreate',
  components: {
    inventoryProductsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/products/create.vue